














import { Component, Vue } from 'vue-property-decorator';
import Store from '@/store';
import { Getters, Mutations } from '@/store/types';
import { ApiService } from '@/services/ApiService';
import { LabelSelectionApi } from '@eurogast/hub-client-typescript';
import { ConfigService } from '@/services/ConfigService';

@Component
export default class LabelSelectionButton extends Vue {
  get labelSelection() {
    return Store.getters[Getters.LabelSelection.getCount];
  }

  public mounted() {
    ApiService.wrap(LabelSelectionApi)
      .getOwnLabelSkus(ConfigService.getTenant(), ConfigService.currentCustomerId)
      .then((res) => {
        Store.commit(Mutations.LabelSelection.setSkuList, res);
        Vue.prototype.$events.$emit('init-label-prints');
      });
  }
}
